<button type="button"
    class="{{bgColor()}} {{textColor()}} hover:{{textHoverColor()}} text-sm whitespace-nowrap border-0 focus:outline-none rounded {{padding()}} {{addClasses()}}"
    (click)="handleClick()"><i class="{{icon()}}"></i></button>